import { filterNonNullValues } from '@/lib/utils'
import Cases from '@/views/cases'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cases/')({
  component: Cases,
  validateSearch: (search) => filterNonNullValues({
    page: search.page ? Number(search.page) : 0,
    page_size: search.page_size ? Number(search.page_size) : 10,
    ordering: typeof search.ordering === 'string' ? search.ordering : null,
    name: typeof search.name === 'string' ? search.name : null,
    types: Array.isArray(search.types) ? search.types : null,
    case_id: typeof search.case_id === 'string' ? search.case_id : null,
    is_archived: typeof search.is_archived === 'string' ? search.is_archived === 'true' : null,
    client: typeof search.client === 'string' ? search.client : null,
    assigned_to: typeof search.assigned_to === 'string' ? search.assigned_to : null,
    status: Array.isArray(search.status) ? search.status : null,
    is_favorite: typeof search.is_favorite === 'boolean' ? search.is_favorite :
      search.is_favorite === 'true' ? true :
        search.is_favorite === 'false' ? false : null
  }),
})